
import { motion } from "framer-motion";
import { fadeUp, staggerContainer, fadeIn } from "./Animations";
import { program } from "@/lib/program-data";
import hero from "/images/hero4.jpg";
import iitc from "@/assets/iitc-white.png";
import mu from "@/assets/mu-white.png";
import edept from "@/assets/edept2.png";
import CTAForm from "./CTAForm";

export default function Hero({
  onApplyClick,
}: {
  onApplyClick: () => void;
}) {
  return (
   <section
  id="top"
  className="relative flex min-h-[92vh] overflow-hidden bg-[#12539F]"
>
  {/* Hero Image */}
  <img
    src={hero}
    alt="Students collaborating"
    className="absolute inset-0 h-full w-full object-cover object-center"
    loading="eager"
    fetchPriority="high"
  />

  {/* Blue Gradient Overlay */}
  <div
    className="
      absolute inset-0
      bg-gradient-to-r
      from-[#12539F]
      from-0%
      via-[#12539F]/75
      via-45%
      to-[#12539F]/20
      to-100%
    "
    aria-hidden="true"
  />

  {/* Optional subtle darkening */}
  <div
    className="absolute inset-0 bg-black/5"
    aria-hidden="true"
  />

  {/* Hero Content */}
  <div
    className="
      container-content
      relative
      z-10
      mx-auto
      w-full
      px-6
      pb-12
      pt-28
      sm:px-10
      sm:pb-16
      lg:px-16
      lg:pb-20
    "
  >
    <div className="grid items-center gap-12 lg:grid-cols-[minmax(0,1fr)_420px] xl:grid-cols-[minmax(0,1fr)_450px]">
      
      {/* ================= LEFT CONTENT ================= */}
      <motion.div
        variants={staggerContainer}
        initial="hidden"
        animate="visible"
        className="max-w-3xl"
      >
    

        {/* Heading */}
        <motion.h1
          variants={fadeUp}
          className="
            max-w-4xl
            text-balance
            text-4xl
            leading-[1.25]
            text-white
            sm:text-[2.75rem]
            lg:text-[3.5rem]
          "
        >
          {program.name}
        </motion.h1>

        {/* Description */}
        <motion.p
          variants={fadeUp}
          className="
            mt-6
            max-w-2xl
            text-balance
            text-lg
            text-white/85
            sm:text-xl
          "
        >
          One semester in India, three in Chicago. <br />Earn a PGP Certificate and
          a U.S. STEM degree with OPT from <br className="hidden md:flex" />Illinois Tech,
          at up to{" "}
          <span className="mr-1 rounded-md bg-[#FBE8C8] px-1.5 py-0.5 text-black">
            ≈30% lower
          </span>
          all-in cost.
        </motion.p>


        {/* CTA Buttons */}
        <motion.div
          variants={fadeUp}
          className="mt-10 flex flex-wrap items-center gap-4"
        >
          <button
            type="button"
            onClick={onApplyClick}
            className="
              rounded-full
              bg-edept-orange
              px-8
              py-4
              text-base
              font-semibold
              text-white
              shadow-card-lg
              transition-transform
              hover:scale-[1.03]
              focus:outline-none
              focus-visible:ring-2
              focus-visible:ring-white
              focus-visible:ring-offset-2
              focus-visible:ring-offset-[#12539F]
            "
          >
            Apply Now
          </button>

          <a
            href="#outcomes"
            className="
              rounded-full
              border
              border-white/40
              px-8
              py-4
              text-base
              font-semibold
              text-white
              transition-colors
              hover:bg-white/10
            "
          >
            See Graduate Outcomes
          </a>
        </motion.div>

        {/* Partner Logos */}
        <motion.div
          variants={fadeIn}
          className="
            mt-12
            flex
            flex-wrap
            items-center
            gap-x-6
            gap-y-4
            border-t
            border-white/15
            pt-7
            text-white/70
          "
        >

           <img
            src={edept}
            alt="Mahindra University logo"
            className="h-8 rounded-md "
          />  

          <img
            src={iitc}
            alt="Illinois Tech logo"
            className="h-11 rounded-md p-2.5"
          /> 

          <img
            src={mu}
            alt="Mahindra University logo"
            className="h-12 rounded-md"
          />
        </motion.div>
      </motion.div>

      {/* ================= RIGHT FORM ================= */}
      <motion.div
        initial={{ opacity: 0, x: 30 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.6, delay: 0.2 }}
        className="
          w-full
          lg:justify-self-end
        "
      >
        <div
          className="
            w-full
            rounded-2xl
            bg-white
            p-6
            shadow-2xl
            sm:p-8
          "
        >
          {/* Form Heading */}
          <div className="mb-6">
            <h2 className="text-2xl font-bold leading-tight text-[#12539F] sm:text-3xl">
              Take the First Step
            </h2>
          </div>

          {/* Your Form Component */}
          <CTAForm />
        </div>
      </motion.div>
    </div>
  </div>
</section>
  );
}

